import Typography from '@material-ui/core/Typography';
import React__default, { useState } from 'react';
import { Link } from '../../components/Link/Link.esm.js';
import '@backstage/core-plugin-api';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import '@material-ui/core/IconButton';
import '@material-ui/core/Snackbar';
import '@material-ui/icons/Close';
import '@material-ui/lab/Alert';
import { coreComponentsTranslationRef } from '../../translation.esm.js';
import 'react-idle-timer';
import '@material-ui/core/Button';
import '@material-ui/core/Dialog';
import '@material-ui/core/DialogActions';
import '@material-ui/core/DialogContent';
import '@material-ui/core/DialogContentText';
import '@material-ui/core/DialogTitle';
import '../../components/Avatar/Avatar.esm.js';
import '../../components/LinkButton/LinkButton.esm.js';
import { CodeSnippet } from '../../components/CodeSnippet/CodeSnippet.esm.js';
import '@material-ui/core/Tooltip';
import '@material-ui/icons/FileCopy';
import 'react-use/esm/useCopyToClipboard';
import '@material-ui/core/useMediaQuery';
import 'react-router-dom';
import '@material-ui/icons/AddCircleOutline';
import 'd3-zoom';
import 'd3-selection';
import '@material-ui/core/styles/useTheme';
import 'dagre';
import 'lodash/debounce';
import '../../components/DependencyGraph/types.esm.js';
import '../../components/DependencyGraph/Node.esm.js';
import '../../components/DependencyGraph/Edge.esm.js';
import '../../components/DismissableBanner/DismissableBanner.esm.js';
import '../../components/EmptyState/EmptyState.esm.js';
import '../../components/EmptyState/MissingAnnotationEmptyState.esm.js';
import '../../components/ErrorPanel/ErrorPanel.esm.js';
import '../../components/FavoriteToggle/FavoriteToggle.esm.js';
import '../../components/ResponseErrorPanel/ResponseErrorPanel.esm.js';
import '../../components/FeatureDiscovery/FeatureCalloutCircular.esm.js';
import '../../components/HeaderIconLinkRow/HeaderIconLinkRow.esm.js';
import '../../components/HeaderIconLinkRow/IconLinkVertical.esm.js';
import '../../components/HorizontalScrollGrid/HorizontalScrollGrid.esm.js';
import '../../components/Lifecycle/Lifecycle.esm.js';
import '../../components/LogViewer/LogViewer.esm.js';
import '../../components/MarkdownContent/MarkdownContent.esm.js';
import '../../components/OAuthRequestDialog/OAuthRequestDialog.esm.js';
import '../../components/OverflowTooltip/OverflowTooltip.esm.js';
import '@material-ui/core/Box';
import '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import '../../components/ProgressBars/GaugeCard.esm.js';
import '../../components/ProgressBars/Gauge.esm.js';
import 'rc-progress';
import '../../components/Select/Select.esm.js';
import '../../components/SimpleStepper/SimpleStepper.esm.js';
import '../../components/SimpleStepper/SimpleStepperStep.esm.js';
import '../../components/Status/Status.esm.js';
import '../../components/StructuredMetadataTable/StructuredMetadataTable.esm.js';
import '../../components/SupportButton/SupportButton.esm.js';
import '../../components/TabbedLayout/TabbedLayout.esm.js';
import 'react-helmet';
import '../Content/Content.esm.js';
import '../HeaderTabs/HeaderTabs.esm.js';
import '../../components/Table/SubvalueCell.esm.js';
import '../../components/Table/Table.esm.js';
import 'react-sparklines';
import '../../components/WarningPanel/WarningPanel.esm.js';

const useStyles = makeStyles(
  (theme) => ({
    title: {
      paddingBottom: theme.spacing(5),
      [theme.breakpoints.down("xs")]: {
        paddingBottom: theme.spacing(4),
        fontSize: theme.typography.h3.fontSize
      }
    }
  }),
  { name: "BackstageErrorPageStackDetails" }
);
function StackDetails(props) {
  const { stack } = props;
  const classes = useStyles();
  const { t } = useTranslationRef(coreComponentsTranslationRef);
  const [detailsOpen, setDetailsOpen] = useState(false);
  if (!detailsOpen) {
    return /* @__PURE__ */ React__default.createElement(Typography, { variant: "h6", className: classes.title }, /* @__PURE__ */ React__default.createElement(Link, { to: "#", onClick: () => setDetailsOpen(true) }, t("errorPage.showMoreDetails")));
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Typography, { variant: "h6", className: classes.title }, /* @__PURE__ */ React__default.createElement(Link, { to: "#", onClick: () => setDetailsOpen(false) }, t("errorPage.showLessDetails"))), /* @__PURE__ */ React__default.createElement(
    CodeSnippet,
    {
      text: stack,
      language: "text",
      showCopyCodeButton: true,
      showLineNumbers: true
    }
  ));
}

export { StackDetails };
//# sourceMappingURL=StackDetails.esm.js.map
